export type WorkflowStep =
  | "setup"
  | "creativeSelection"
  | "creativeDetails"
  | "generating"
  | "structures"
  | "custom-builder"
  | "adsets"
  | "review"
  | "processing"
  | "success"
  | "error"

export type CampaignType =
  | "Cold Prospecting DR"
  | "Warm Prospecting DR"
  | "Lukewarm Prospecting DR"
  | "Retention DR"
  | "Demand Generation - Engagement"
  | "Demand Generation - Traffic"
  | "Demand Generation - Awareness"
  | ""
export type OptimizationGoal =
  | "Max Conversions"
  | "Max Conversion Value"
  | "Landing Page Views"
  | "Post Engagements"
  | "Profile Visits"
  | "Facebook Page Likes"
  | "Web Visits"
  | ""
export type AttributionModel = "Standard" | "Incremental" | ""
export type AttributionWindow =
  | "7d Click"
  | "7d Click + 1d View"
  | "7d Click + 1d Engaged View"
  | "1d Click"
  | ""
export type AdsetStrategy =
  | "Single Adset"
  | "Split by Creative"
  | "Product Groups"
  | ""
export type TargetingGeography =
  | "United States"
  | "Canada"
  | "North America"
  | "Europe"
  | "Global"
  | ""
export type TargetingGender = "All" | "Male" | "Female" | ""
export type Placements =
  | "All Placements"
  | "Advantage+"
  | "Feed/Stories/Reels only"
  | "Feed only"
  | "Stories/Reels only"
  | ""
export type BudgetOptimization = "Campaign (CBO)" | "Adset (ABO)" | ""
export type BiddingStrategy = "Max Volume" | "Cost Cap" | "ROAS Target" | ""
export type Platform = "Facebook" | "Instagram" | "Audience Network"

export interface SelectedCreative {
  id: string
  type: "ad" | "organic"
  thumbnail: string
  title: string
  mediaChannel: string
  metrics: {
    brandValue: number
    spend?: number
    purchaseValue?: number
    comments?: number
    likes?: number
    shares?: number
    saves?: number
    reach?: number
  }
}

export interface Adset {
  id: string
  title: string
  description?: string
  exampleHandles?: string[]
  creativeIds?: string[]
}

export interface AdsetStructure {
  name: string
  description: string
  adsets: {
    title: string
    description: string
    exampleHandles: string[]
    creativeIds?: string[]
  }[]
}

export interface CreativeOverrides {
  destinationUrl?: string
  headline?: string
  primaryText?: string
  callToAction?: string
}

export interface CampaignData {
  campaignType: CampaignType
  optimizationGoal: OptimizationGoal
  attributionModel: AttributionModel
  attributionWindow: AttributionWindow
  adsetStrategy: AdsetStrategy
  targetingGeography: TargetingGeography
  targetingGender: TargetingGender
  placements: Placements
  ageMin: number
  ageMax: number
  ageRanges: string[]
  platforms: Platform[]
  budgetOptimization: BudgetOptimization
  biddingStrategy: BiddingStrategy
  budgetAmount: number
  creativeOverrides?: CreativeOverrides
}

export const DEFAULT_CAMPAIGN_DATA: CampaignData = {
  campaignType: "",
  optimizationGoal: "",
  attributionModel: "",
  attributionWindow: "",
  adsetStrategy: "",
  targetingGeography: "",
  targetingGender: "",
  placements: "",
  ageMin: 0,
  ageMax: 0,
  ageRanges: [],
  platforms: ["Facebook", "Instagram", "Audience Network"],
  budgetOptimization: "",
  biddingStrategy: "",
  budgetAmount: 0,
}
